(() => {
  const key = 'metalnook-browse-return-v1';
  const lifetime = 2 * 60 * 60 * 1000;
  const listing = url => /\/collections\/[^/]+\/?$/.test(url.pathname) || /\/search\/?$/.test(url.pathname);
  const productPath = url => url.pathname.match(/\/products\/[^/]+\/?$/)?.[0];
  const read = () => {
    try {
      const entry = JSON.parse(sessionStorage.getItem(key));
      const url = new URL(entry.url);
      if (url.origin !== location.origin || !listing(url) || Date.now() - entry.time > lifetime || !Number.isFinite(entry.y) || entry.y < 0) return null;
      return entry;
    } catch { return null; }
  };
  const write = entry => { try { sessionStorage.setItem(key, JSON.stringify(entry)); } catch {} };
  const here = new URL(location.href);
  if (listing(here)) {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const destination = new URL(link.href, location.href);
      const product = productPath(destination);
      if (destination.origin === location.origin && product) {
        write({ url: location.href, product, y: window.scrollY, time: Date.now() });
      }
    });
    const restore = () => {
      const entry = read();
      if (!entry || entry.url !== location.href) return;
      // Repeat after layout settles; cancel when the shopper takes control.
      let active = true;
      const stop = () => { active = false; };
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, stop, { once: true, passive: true }));
      [0, 100, 350, 800].forEach(delay => setTimeout(() => {
        if (active) window.scrollTo({ top: entry.y, behavior: 'instant' });
      }, delay));
    };
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore, { once: true });
    window.addEventListener('pageshow', event => { if (event.persisted) restore(); });
  } else if (productPath(here)) {
    const entry = read();
    const link = document.querySelector('[data-mn-browse-return]');
    if (!entry || !link || entry.product !== productPath(here)) return;
    // A direct/shared arrival must not inherit unrelated tab history.
    let referrer;
    try { referrer = new URL(document.referrer); } catch { return; }
    if (referrer.origin !== location.origin || referrer.href !== entry.url) return;
    link.href = entry.url;
    const label = document.createTextNode(' Back to browsing');
    [...link.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
    link.append(label);
  }
})();
